module.exports = __webpack_public_path__ + "static/media/feature-analyse.a106b75d.png";